import { BASE_API } from "../utils/constants";
import { authHeader } from "./token";

// Facturación electrónica (hoy solo modo prueba). Los errores del servidor
// vienen como { detail } o { campo: [mensaje] }: se convierten en un Error con
// un texto para mostrar tal cual.
function errorText(body, fallback) {
  if (!body || typeof body !== "object") return fallback;
  if (body.detail) return String(body.detail);
  const first = Object.values(body)[0];
  return String(Array.isArray(first) ? first[0] : first || fallback);
}

async function request(path, token, options = {}) {
  const response = await fetch(`${BASE_API}/api/${path}`, {
    ...options,
    headers: {
      ...authHeader(token),
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) throw new Error(errorText(body, `Error ${response.status}`));
  return body;
}

export const getIssuerApi = (token) => request("invoicing/issuer/", token);

export const updateIssuerApi = (data, token) =>
  request("invoicing/issuer/", token, { method: "PATCH", body: JSON.stringify(data) });

export const getSeriesApi = (token) => request("invoicing/series/", token);

export const addSeriesApi = (data, token) =>
  request("invoicing/series/", token, { method: "POST", body: JSON.stringify(data) });

export const updateSeriesApi = (id, data, token) =>
  request(`invoicing/series/${id}/`, token, { method: "PATCH", body: JSON.stringify(data) });

export const emitComprobanteApi = (paymentId, docType, token, summarized = false) =>
  request(`payments/${paymentId}/comprobante/`, token, {
    method: "POST",
    body: JSON.stringify({ doc_type: docType, summarized }),
  });

export const getComprobantesApi = (params, token) =>
  request(`invoicing/comprobantes/?${new URLSearchParams(params).toString()}`, token);

// Descarga el PDF a la carpeta de Descargas (fetch con el token → blob → enlace).
export async function downloadComprobantePdfApi(comprobante, token) {
  const response = await fetch(`${BASE_API}/api/invoicing/comprobantes/${comprobante.id}/pdf/`, {
    headers: authHeader(token),
  });
  if (!response.ok) throw new Error("No se pudo descargar el comprobante.");
  const url = URL.createObjectURL(await response.blob());
  const link = document.createElement("a");
  link.href = url;
  link.download = `${comprobante.full_number}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Valida el número y, si el negocio configuró la consulta, trae el nombre y la
// dirección de SUNAT/RENIEC. Nunca falla: { valid, configured, found, ... }.
export const lookupDocumentApi = (docType, docNumber, token) =>
  request(
    `customers/lookup/?${new URLSearchParams({ doc_type: docType, doc_number: docNumber })}`,
    token
  );
